import t, { forwardRef as te, useRef as A, useState as u, useCallback as D, useImperativeHandle as re } from "react";
import e from "./index270.mjs";
import { BACKGROUND_DRAWER as f, DRAWER_BASE_CLASS as r } from "./index172.mjs";
import { Icon as ne } from "./index10.mjs";
import { DrawerVariants as oe } from "./index271.mjs";
import { View as i } from "./index27.mjs";
import { Flex as T } from "./index8.mjs";
import { Typography as I } from "./index24.mjs";
import { Button as G } from "./index23.mjs";
import { ButtonVariants as ae } from "./index252.mjs";
import { useOnClickOutside as se } from "./index249.mjs";
import { CSSTransition as L } from "react-transition-group";
import M from "classnames";
import { FLEX_JUSTIFY_CONTENT as E, FLEX_DIRECTION as ce } from "./index157.mjs";
import { TYPOGRAPHY_SIZES as k, TYPOGRAPHY_WEIGHTS as le } from "./index168.mjs";
const ie = ({
  classes: a,
  isMaximized: n
}) => M(
  e[r],
  a,
  n && e[`${r}--maximized`]
), me = ({
  isExpandable: a,
  isExpanded: n,
  expandableIconOnClick: s
}) => a ? /* @__PURE__ */ t.createElement(T, { justifyContent: E.CENTER }, /* @__PURE__ */ t.createElement(
  ne,
  {
    classes: e[`${r}__arrow`],
    name: n ? "arrows/chevron-down" : "arrows/chevron-up",
    "data-testid": "chevron",
    onClick: s
  }
)) : /* @__PURE__ */ t.createElement(T, { justifyContent: E.CENTER }, /* @__PURE__ */ t.createElement(i, { classes: e[`${r}__box`] })), ue = ({
  title: a,
  description: n,
  hasCloseButton: s = !0,
  clickCloseButton: d
}) => /* @__PURE__ */ t.createElement(i, { classes: e[`${r}__header`] }, /* @__PURE__ */ t.createElement(
  T,
  {
    direction: ce.COLUMN,
    justifyContent: n ? E.FLEX_START : E.CENTER
  },
  /* @__PURE__ */ t.createElement(
    I,
    {
      text: a,
      size: k[2],
      weight: le.SEMIBOLD,
      margin: "0"
    }
  ),
  n ? /* @__PURE__ */ t.createElement(
    I,
    {
      classes: `${e[`${r}__description`]}`,
      text: n,
      margin: "8px 0px 0px 0px",
      size: k.N1
    }
  ) : null
), s ? /* @__PURE__ */ t.createElement(
  G,
  {
    onClick: d,
    classes: `${e[`${r}__close-icon`]}`,
    iconL: "actions/close-banner",
    variant: ae.GHOST,
    "data-testid": "icon-close-drawer",
    name: "close"
  }
) : null), we = te(
  ({
    title: a,
    description: n,
    dismissable: s = !0,
    closeOnOutsideClick: d = !0,
    hasCloseButton: $ = !0,
    submitButtonLabel: _,
    isSubmitButtonDisabled: z = !1,
    isExpandable: m = !1,
    onSubmit: B = () => {
    },
    onClose: S = () => {
    },
    onOpen: h = () => {
    },
    "data-testid": H,
    children: q,
    bodyHeader: R,
    bodyFooter: v,
    defaultOpened: F,
    classes: P,
    variant: j = oe.GREY,
    overflowBody: U = "auto",
    isExpanded: C = !1,
    expandableIconOnClick: V = () => {
    }
  }, W) => {
    const p = A(null), x = A(null), [y, N] = u(F), [X, w] = u(!1), [b, J] = u(0), [K, g] = u(!1), O = D(() => {
      var o, c;
      h(), N(!0), (o = document.querySelector("body")) == null || o.classList.add(e.no_scroll), (c = document.querySelector("html")) == null || c.classList.add(e.no_scroll);
    }, [h]), l = D(() => {
      var o, c;
      s && (S(), N(!1), g(!1), (o = document.querySelector("body")) == null || o.classList.remove(e.no_scroll), (c = document.querySelector("html")) == null || c.classList.remove(e.no_scroll));
    }, [S, s]);
    se(p, () => d && l());
    const Z = (o) => {
      m || (w(!0), J(o.touches[0].clientY));
    }, Q = (o) => {
      if (!m && X) {
        const Y = o.touches[0].clientY - b;
        Y > 50 && l(), Y < -50 && g(!0);
      }
    }, ee = () => {
      m || w(!1);
    };
    return re(
      W,
      () => ({
        open: O,
        close: l
      }),
      [l, O]
    ), /* @__PURE__ */ t.createElement(t.Fragment, null, m && !C ? null : /* @__PURE__ */ t.createElement(
      L,
      {
        in: y,
        timeout: 900,
        classNames: {
          enter: e[`${f}-enter`],
          enterActive: e[`${f}-enter-active`],
          exitActive: e[`${f}-exit-active`]
        },
        nodeRef: x,
        unmountOnExit: !0
      },
      /* @__PURE__ */ t.createElement("div", { className: e[f], ref: x })
    ), /* @__PURE__ */ t.createElement(
      L,
      {
        in: y,
        timeout: 700,
        classNames: {
          enter: e[`${r}-enter`],
          enterActive: e[`${r}-enter-active`],
          exitActive: e[`${r}-exit-active`]
        },
        nodeRef: p,
        unmountOnExit: !0
      },
      /* @__PURE__ */ t.createElement(
        "div",
        {
          className: ie({
            classes: P,
            isMaximized: K
          }),
          "data-testid": H,
          ref: p,
          onTouchStart: Z,
          onTouchMove: Q,
          onTouchEnd: ee
        },
        /* @__PURE__ */ t.createElement(
          i,
          {
            classes: M([
              e[`${r}__overlay`],
              e[`${r}__overlay--${j}`]
            ])
          },
          /* @__PURE__ */ t.createElement(
            me,
            {
              isExpandable: !0,
              isExpanded: C,
              expandableIconOnClick: V
            }
          ),
          a || n || $ ? /* @__PURE__ */ t.createElement(
            ue,
            {
              title: a,
              description: n,
              hasCloseButton: $,
              clickCloseButton: l
            }
          ) : null,
          /* @__PURE__ */ t.createElement(
            i,
            {
              classes: `${e[`${r}__body`]}`,
              style: { overflow: U }
            },
            R || null,
            /* @__PURE__ */ t.createElement(
              "div",
              {
                className: `${e[`${r}__body-content`]}`
              },
              q,
              _ || v ? /* @__PURE__ */ t.createElement(i, { classes: "drawer__body-footer" }, v || null, _ ? /* @__PURE__ */ t.createElement(
                G,
                {
                  disabled: z,
                  onClick: B,
                  label: _,
                  name: "submit"
                }
              ) : null) : null
            )
          )
        )
      )
    ));
  }
);
export {
  f as BACKGROUND_DRAWER,
  r as DRAWER_BASE_CLASS,
  we as Drawer,
  we as default
};
